import styled from 'styled-components';

export const Container = styled.div`
  .loading-bars {
    display: inline-block;
    position: absolute;
    width: 18px;
    top: 8px;
    right: 20px;
  }
  .loading-bars.delete-word,
  .loading-bars.load-save-task,
  .loading-bars.authenticate-document-button,
  .loading-bars.conlicitaseg-continue-quote {
    display: inline-block;
    position: relative;
    width: 13px;
    height: 18px;
    top: 1px;
    right: 0;
  }

  .loading-bars.conlicitaseg-continue-quote {
    margin-left: 6px;

    span {
      background: ${(props) => props.theme.$white};
    }
  }
  .loading-bars span {
    display: inline-block;
    position: absolute;
    left: 0;
    width: 3px;
    background: ${(props) => props.theme.$gray600};
    animation: loadingBars 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  .loading-bars.monitoring-message-loader {
    right: 0px;
    top: 0;
  }
  .loading-bars span:nth-child(1) {
    left: 0;
    min-height: 10px;
    animation-delay: -0.24s;
  }
  .loading-bars span:nth-child(2) {
    left: 5px;
    min-height: 10px;
    animation-delay: -0.12s;
  }
  .loading-bars span:nth-child(3) {
    left: 10px;
    min-height: 10px;
    animation-delay: 0;
  }
  .loading-bars.delete-comment-loading {
    right: 5px;
    top: -2px;
  }
  .loading-bars.delete-question-loading {
    right: 5px;
    top: 8px;
  }

  .loading-bars.solicited-edital-loading {
    right: -15px;
    top: 0;
    span {
      background: ${(props) => props.theme.$gold};
    }
  }

  .loading-bars.create-comment-loading {
    right: 0;
    top: 0;
  }

  .loading-bars.monitoring-button {
    left: 10px;
    top: -15px;

    span {
      background: ${(props) => props.theme.$white};
    }

    @media only screen and (max-width: 768px) {
      top: 0;
    }
  }

  .loading-bars.authenticate-document-button {
    right: 0;
    top: 0;

    span {
      background: ${(props) => props.theme.$white};
    }
  }

  .loading-bars.bidding-chat {
    right: -24px;
    top: 0;
  }

  .loading-bars.chatbot-loading {
    right: -24px;
    top: 0;

    span {
      background: ${(props) => props.theme.$white};
    }
  }

  .loading-bars.save-question-loading {
    right: -20px;
    top: 3px;
  }

  @keyframes loadingBars {
    0% {
      top: -2px;
      height: 14px;
    }
    50%,
    100% {
      top: 6px;
      height: 10px;
    }
  }
`;
